// tooltips
function initTooltip() {
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

/*
document.addEventListener("DOMContentLoaded", () => {
  initTooltip();
});*/